import { updateContent } from '@cotyorg/ccx-server/modules/content/actions';

export const setVtoActualProductSku = ({ actualProductSku }) =>
  updateContent({
    key: 'vto',
    data: {
      actualProductSku,
    },
  });

export const setVtoScriptLoaded = ({ vtoScriptLoaded }) =>
  updateContent({
    key: 'vto',
    data: {
      vtoScriptLoaded,
    },
  });

export const setVtoActualProductSlug = ({ actualProductSlug }) =>
  updateContent({
    key: 'vto',
    data: {
      actualProductSlug,
    },
  });

export const setVtoControlsHeight = ({ vtoControlsHeight }) =>
  updateContent({
    key: 'vto',
    data: {
      vtoControlsHeight,
    },
  });

export const setSelectedFilters = ({ selectedFilters }) =>
  updateContent({
    key: 'vto',
    data: {
      selectedFilters,
    },
  });

export const setActiveTab = ({ activeTab }) =>
  updateContent({
    key: 'vto',
    data: {
      activeTab,
    },
  });
